import { render, staticRenderFns } from "./RecruiterDashBoard.vue?vue&type=template&id=c6df6e80&scoped=true"
import script from "./RecruiterDashBoard.vue?vue&type=script&lang=js"
export * from "./RecruiterDashBoard.vue?vue&type=script&lang=js"
import style0 from "./RecruiterDashBoard.vue?vue&type=style&index=0&id=c6df6e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6df6e80",
  null
  
)

export default component.exports